import { FC } from 'react';
import { selectSelectedEnvId } from 'app/containers/HiikoEnv/slice/selectors';
import { RouteConstants } from 'app/routes';
import { useSelector } from 'react-redux';
import { generatePath, useHistory } from 'react-router';
import { ITaskFilters, ITaskListState, TaskListSort } from '../../slice/types';
import TaskListTableFilterTags from '../TaskListTableFilterTags/TaskListTableFilterTags';

import TasksTable from 'app/components/TasksTable/TasksTable';

interface IProps {
  fieldId?: number;
  taskListState: ITaskListState;
  setFilters: (filters: ITaskFilters) => void;
  setCurrentPage: (page: number) => void;
  setSort: (payload: TaskListSort) => void;
}

const TaskListTable: FC<IProps> = ({
  fieldId,
  taskListState,
  setFilters,
  setCurrentPage,
  setSort,
}) => {
  const history = useHistory();

  const envId = useSelector(selectSelectedEnvId);
  const { filters, loading, currentPage, total, tasksArr } = taskListState;

  const openTaskDetails = (taskId: number) => () => {
    if (envId) {
      let redirectUrl = generatePath(RouteConstants.task.details, {
        envId,
        taskId,
      });

      if (fieldId) {
        redirectUrl = generatePath(
          RouteConstants.task.detailsOpenedFromFieldTasks,
          {
            envId,
            taskId,
            fieldId,
          },
        );
      }
      history.push(redirectUrl);
    }
  };

  const onPageChange = (page: number) => {
    setCurrentPage(page);
  };

  return (
    <>
      <TaskListTableFilterTags filters={filters} setFilters={setFilters} />
      <TasksTable
        tasksArr={tasksArr}
        onRowClick={openTaskDetails}
        onPageChange={onPageChange}
        currentPage={currentPage}
        total={total}
        loading={loading}
        setSort={setSort}
      />
    </>
  );
};

export default TaskListTable;
